import React from "react";
import { UnfilledYellowButton, YellowButton } from "../buttons";
import { dummyClick, emptyFunction } from "../utilities";

const UnlockConfirm = ({
  episodePrice,
  episodeTitle,
  onCancelClick,
  onConfirmClick,
  storyTitle,
  storySlug,
  userBalance,
  t: {
    cancel,
    newBalance,
    popCoins,
    popCoinsDeducted,
    price,
    unlock,
    unlocking,
    walletBalance
  }
}) => (
  <div>
    <div className="for-react-notice notice-message" />
    <div className="t-ph2">
      <h1 className="tc f3">
        {unlocking.replace("%{episode}", episodeTitle)}
      </h1>
      <div className="f--2 t-mt3">
        <p className="t-pb2">
          <strong>{episodePrice}</strong> {popCoinsDeducted}
        </p>
        <table className="a-transaction w-100 t-mb3">
          <tbody>
            <tr className="">
              <td className="tl">{walletBalance}</td>
              <td className="tr">
                <strong>{userBalance}</strong> <small>{popCoins}</small>
              </td>
            </tr>
            <tr className="orange-1">
              <td className="tl">{price}</td>
              <td className="tr">
                <strong>-{episodePrice}</strong> <small>{popCoins}</small>
              </td>
            </tr>
            <tr className="green-4">
              <td className="tl">{newBalance}</td>
              <td className="tr">
                <strong>{userBalance - episodePrice}</strong>{" "}
                <small>{popCoins}</small>
              </td>
            </tr>
          </tbody>
        </table>

        <p className="ttu t-mt5 t-pb2">
          <UnfilledYellowButton
            className="t-mt1 ttu db w-40 px3 py1"
            text={cancel}
            onClick={onCancelClick}
          />
          <YellowButton
            className="t-mt1 ttu db w-40 fr px3 py1"
            text={unlock}
            onClick={onConfirmClick}
          />
        </p>
      </div>
    </div>
  </div>
);

UnlockConfirm.defaultProps = {
  t: {
    cancel: "EN cancel",
    newBalance: "EN newBalance",
    popCoins: "EN popCoins",
    popCoinsDeducted: "EN popCoinsDeducted",
    price: "EN price",
    unlock: "EN unlock",
    unlocking: "EN unlocking",
    walletBalance: "EN walletBalance"
  },
  onCancelClick: e => {
    e.preventDefault();
    document.dispatchEvent(new KeyboardEvent("keyup", { key: "Escape" }));
  },
  onConfirmClick: dummyClick,
  storySlug: "/",
  userBalance: 0
};

export { UnlockConfirm };
